import styled from '@emotion/styled'

const SVG = styled.svg`
	fill: ${({ fill, theme }) => (fill ? fill : theme.colors.white)};
`
export default SVG
